// 故障排除页面内容
export const troubleshootingPages = {
  'not-installing': {
    h1: 'GB WhatsApp Not Installing – Fixes That Work',
    subtitle: 'Your APK downloaded but the install failed? Here are the most common causes and how to fix them step by step.',
    badge: 'Troubleshooting',
    sections: [
      {
        h2: 'Why GB WhatsApp Won\'t Install',
        paragraphs: [
          'Install failures are more common than you might expect, but they are usually straightforward to fix once you identify the cause. The problem is rarely the APK file itself — it is far more often a phone setting, a storage issue, or a signature mismatch between different mod sources.',
          'Work through the fixes below in order, since most users solve the problem within a few minutes. Write down the exact error message if one appears, as it helps you pick the right fix faster. A simple phone restart before retrying also clears stuck install sessions on some devices.',
        ],
      },
      {
        h2: 'Fix 1: Enable Unknown Sources',
        steps: [
          'Open Settings on your Android phone.',
          'Go to Security or Privacy → Install unknown apps.',
          'Find your browser (Chrome, etc.) and turn on "Allow from this source".',
          'Try installing the APK again.',
        ],
        paragraphs: [
          'On Android 8 and above, install permission is granted per app rather than globally. Make sure you enable it specifically for the browser or file manager you used to download the APK — enabling it for one app does not apply to others.',
        ],
      },
      {
        h2: 'Fix 2: Free Up Storage Space',
        paragraphs: [
          'GB WhatsApp needs roughly 200 MB of free space for the APK and installation process. Head to Settings → Storage to check how much room you have, then delete unused apps, old photos, or cached files if you are running low.',
          'If the downloaded APK file looks significantly smaller than 50 MB, the download may have been corrupted or interrupted. Clear your browser download cache and download the file again over a stable Wi-Fi connection.',
        ],
      },
      {
        h2: 'Fix 3: Signature Mismatch Error',
        paragraphs: [
          'If you see "App not installed" with no other explanation, you likely have a GB WhatsApp build from a different source than the APK you are trying to install now. Android treats APKs with different signatures as incompatible, even if they are the same app.',
          'The fix is to back up your chats, uninstall the current app, and do a fresh install using our <a href="/gb-whatsapp-install/"><strong>install guide</strong></a>. Do not skip the backup step — uninstalling without one permanently deletes chats stored locally on your phone.',
        ],
      },
      {
        h2: 'Fix 4: Corrupted Download',
        paragraphs: [
          'A partial or corrupted download is another frequent cause of install failure, especially on unstable mobile data connections. Delete the APK file from your Downloads folder and grab a fresh copy from a trusted source on your phone, preferably over Wi-Fi.',
          'If you were trying to update an existing installation, follow our <a href="/gb-whatsapp-update/"><strong>GB WhatsApp update guide</strong></a> to install over the old app without uninstalling — this preserves your chats and avoids signature conflicts when both files come from the same source.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Does my phone support GB WhatsApp?',
            answer: 'You need Android 5.0 or higher, which covers most phones from 2016 onward. Very old devices may struggle with the latest APK, in which case our old versions page lists previous builds that work better on older hardware.',
          },
          {
            question: 'Can I install without uninstalling official WhatsApp?',
            answer: 'No — both apps use the same package name, so only one can be installed at a time. You must uninstall official WhatsApp first, but back up your chats in Google Drive before doing so.',
          },
          {
            question: 'What if I already have FM or YoWhatsApp installed?',
            answer: 'Uninstall the other mod first, since only one WhatsApp mod can occupy the package slot at a time. Back up your chats before uninstalling, then install GB WhatsApp fresh from a trusted source.',
          },
        ],
      },
    ],
  },

  'not-connecting': {
    h1: 'GB WhatsApp Not Connecting – Network Fixes',
    subtitle: 'Stuck on "Connecting" or "Checking for new messages"? Here is how to diagnose and fix the problem.',
    badge: 'Troubleshooting',
    sections: [
      {
        h2: 'Common Connection Problems',
        paragraphs: [
          'Connection issues in GB WhatsApp can stem from your internet, phone settings, an outdated app version, or occasionally from WhatsApp server outages that affect all clients equally. Before assuming the mod is broken, it helps to figure out whether the problem is specific to GB WhatsApp or affects your entire network.',
          'Open a few websites or other apps to confirm your connection is working normally. If official WhatsApp also fails to connect, the issue is likely with WhatsApp servers or your network provider rather than the mod itself. Weak Wi-Fi signal is another common culprit that causes endless "Connecting" loops — moving closer to your router or switching to mobile data often resolves it quickly.',
        ],
      },
      {
        h2: 'Quick Fixes to Try First',
        steps: [
          'Check your internet — open a website in your browser to confirm Wi-Fi or data works.',
          'Toggle airplane mode on for 10 seconds, then off.',
          'Force close GB WhatsApp and reopen it.',
          'Restart your phone.',
        ],
        paragraphs: [
          'If GB WhatsApp is not connecting to the server, start by confirming your network is working normally through other apps or websites. A quick airplane mode toggle resets your radio connection, and force-closing the app clears any stuck session that may be preventing a fresh handshake with WhatsApp servers.',
        ],
      },
      {
        h2: 'Update the App',
        paragraphs: [
          'An outdated GB WhatsApp version may fail to connect because older builds sometimes use deprecated server protocols or lack recent connection fixes. Download the latest APK from our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a> and install it over your current version without uninstalling first.',
          'Only uninstall before updating if installing over the existing app fails with a signature error. In most cases, a simple over-the-top update is all you need to restore normal connectivity.',
        ],
      },
      {
        h2: 'Check Date and Time Settings',
        paragraphs: [
          'Incorrect date or time settings on your phone can prevent WhatsApp from establishing a secure connection to its servers, since the app relies on accurate timestamps for authentication. Go to Settings → Date & Time and enable "Automatic date and time" to sync with your network provider.',
          'After correcting the time, force close GB WhatsApp and reopen it. This simple fix resolves connection issues more often than people expect, especially after traveling across time zones or manually adjusting clock settings.',
        ],
      },
      {
        h2: 'Still Not Working?',
        paragraphs: [
          'If the basic fixes above did not help, try clearing GB WhatsApp cache through Settings → Apps → GB WhatsApp → Storage → Clear Cache. Do not tap Clear Data, as that removes your locally stored chats.',
          'VPN and proxy apps are another common blocker — turn them off and try connecting again. If nothing works, back up your chats and follow our <a href="/gb-whatsapp-update/"><strong>GB WhatsApp update guide</strong></a> to reinstall the latest APK cleanly from a trusted source.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Is WhatsApp down?',
            answer: 'WhatsApp servers occasionally experience outages that affect all users regardless of which client they use. Check whether official WhatsApp also has connection issues — if it does, the problem is on WhatsApp\'s end and you will need to wait it out.',
          },
          {
            question: 'Does VPN cause connection problems?',
            answer: 'Yes, VPNs and proxy apps frequently interfere with WhatsApp connections because they route traffic through servers that WhatsApp may block or throttle. Disable your VPN, reconnect, and see if the problem clears.',
          },
        ],
      },
    ],
  },

  'otp-not-received': {
    h1: 'GB WhatsApp OTP Not Received – Verification Help',
    subtitle: 'Not getting the 6-digit verification code? Here is what to check before you give up on setup.',
    badge: 'Troubleshooting',
    sections: [
      {
        h2: 'Why the OTP Code May Not Arrive',
        paragraphs: [
          'WhatsApp sends a 6-digit code via SMS or automated phone call to verify your number during setup. Delays are common and usually have a straightforward explanation — weak signal, SMS filtering, or requesting too many codes in quick succession can all block delivery.',
          'OTP issues are especially frequent on new installs and are rarely caused by the GB WhatsApp mod itself. Before blaming the app, confirm your phone can receive normal SMS from other services. Requesting multiple codes in a row triggers a wait timer on WhatsApp\'s end, so patience between attempts matters.',
        ],
      },
      {
        h2: 'Step-by-Step OTP Fixes',
        steps: [
          'Double-check your phone number and country code.',
          'Make sure your SIM card has signal and can receive SMS.',
          'Wait at least 60 seconds — codes can be delayed.',
          'Tap "Call me" to get the code via automated phone call.',
          'Do not request the code too many times — this triggers a wait timer.',
        ],
      },
      {
        h2: 'Check SMS and Call Blocking',
        paragraphs: [
          'Some phones automatically filter messages from unknown senders into a spam or blocked folder, which means your OTP may have arrived without you noticing. Check those folders and temporarily disable any SMS filtering apps that could be intercepting the code.',
          'If you use a dual SIM phone, make sure the correct SIM is selected for verification — WhatsApp sends the code to the number you entered, not necessarily the SIM that is currently active for data. New to GB WhatsApp? Our <a href="/gb-whatsapp-install/"><strong>install guide</strong></a> walks through a clean first-time setup that avoids common verification pitfalls.',
        ],
      },
      {
        h2: 'Reinstall and Retry',
        paragraphs: [
          'If verification keeps failing after trying the steps above, uninstall GB WhatsApp and reinstall from our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a>. Old APK builds sometimes have login bugs that newer releases have already fixed.',
          'After reinstalling, wait at least 60 seconds before requesting a new OTP code. Rushing multiple requests in a row is one of the most common reasons verification gets temporarily blocked.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Can I use email verification?',
            answer: 'No — WhatsApp only verifies accounts through SMS or an automated phone call to your mobile number. There is no email-based verification option.',
          },
          {
            question: 'What if my number is already registered?',
            answer: 'If your number is active on another device, you need to log out there first or use WhatsApp\'s account transfer option. A number cannot be registered on two devices simultaneously.',
          },
        ],
      },
    ],
  },

  'update-failed': {
    h1: 'GB WhatsApp Update Failed – How to Fix It',
    subtitle: 'Could not install the new version over your old one? Here is what went wrong and how to recover.',
    badge: 'Troubleshooting',
    sections: [
      {
        h2: 'Why Updates Fail',
        paragraphs: [
          'The most common reason for a failed GB WhatsApp update is a signature mismatch — your current installation came from a different download source than the new APK you are trying to install. Android treats these as incompatible apps, even though they are both GB WhatsApp.',
          'Less common causes include insufficient storage, a corrupted download file, or an interrupted install process. The good news is that a failed update does not delete your chats — your data stays safe on your phone until you explicitly uninstall. Review our <a href="/gb-whatsapp-update/"><strong>GB WhatsApp update guide</strong></a> before trying again, since installing over the existing app is always the safest approach.',
        ],
      },
      {
        h2: 'Fix: Install Over Existing App',
        steps: [
          'Download the update from the same source as your current version.',
          'Use our <a href="/gb-whatsapp-latest-version/"><strong>latest version download</strong></a> for the most recent APK.',
          'Open the APK and tap Install — do not uninstall first.',
          'If install succeeds, open the app and check your chats.',
        ],
      },
      {
        h2: 'Fix: Fresh Install (Last Resort)',
        steps: [
          'Back up chats: Settings → Chats → Back up chats.',
          'Uninstall the current GB WhatsApp.',
          'Download and install the new APK.',
          'Verify your number and restore the backup.',
        ],
        paragraphs: [
          'A fresh install is the right move when signature mismatch makes an over-the-top update impossible. Use the same download source for both the old and new APK files — mixing sources from different websites is the number one cause of update failure.',
          'After reinstalling, restore your backup during the setup screen when prompted. Skipping this step means starting with an empty chat history, even though your Google Drive backup is still available.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Will I lose chats if the update fails?',
            answer: 'Your chats remain safe as long as you do not uninstall without backing up first. A failed update attempt does not delete anything — it simply means the new version could not be installed over the old one.',
          },
          {
            question: 'Should I try an old version instead?',
            answer: 'Only if the latest version keeps failing after you have tried a fresh install from a single trusted source. Our old versions page lists previous APK files that may work better on certain devices.',
          },
        ],
      },
    ],
  },

  'restore-backup': {
    h1: 'How to Restore GB WhatsApp Backup',
    subtitle: 'Lost chats after reinstalling? Your backup may still be recoverable if you know where to look.',
    badge: 'Troubleshooting',
    sections: [
      {
        h2: 'Where Your Backup Is Stored',
        paragraphs: [
          'GB WhatsApp can back up your chats to Google Drive or local phone storage, and the backup is tied to both your Google account and phone number. If you backed up before uninstalling, you can restore everything during the setup process on a fresh install.',
          'Google Drive backups survive uninstall and work across most Android phones, making them the most reliable option. Local backups, on the other hand, are lost if you format the phone or clear all app data. Check the backup date in GB WhatsApp settings before reinstalling — an outdated backup may miss your most recent conversations.',
        ],
      },
      {
        h2: 'Restore from Google Drive',
        steps: [
          'Install GB WhatsApp from our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a>.',
          'Open the app and verify your phone number.',
          'When prompted, tap Restore to load chats from Google Drive.',
          'Wait for the restore to finish — this may take several minutes.',
        ],
      },
      {
        h2: 'Restore from Local Backup',
        steps: [
          'Make sure the backup file exists in your phone storage or SD card.',
          'During setup, GB WhatsApp should detect the local backup automatically.',
          'Tap Restore and wait for the process to complete.',
        ],
        paragraphs: [
          'Local backups are convenient when you do not use Google Drive, but they are more fragile — clearing app data or switching phones without transferring the file means losing them permanently. If you need help with the install steps, see our <a href="/gb-whatsapp-install/"><strong>install guide</strong></a>.',
        ],
      },
      {
        h2: 'Backup Not Found?',
        paragraphs: [
          'If GB WhatsApp cannot find your backup during setup, the most likely cause is a mismatched Google account or phone number. Make sure you are signed into the same Google account and verifying the same number you used when the backup was created.',
          'Local backups are deleted if you cleared app data or formatted your phone, so there is no way to recover them after that. For future safety, enable auto-backup under Settings → Chats → Back up chats and set it to Daily or Weekly so you always have a recent copy available.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Can I restore an official WhatsApp backup in GB WhatsApp?',
            answer: 'Yes, in most cases. Back up your chats in official WhatsApp first, then install GB WhatsApp and restore during setup. The backup format is compatible between the two apps.',
          },
          {
            question: 'How long are backups kept on Google Drive?',
            answer: 'WhatsApp backups on Google Drive do not expire on their own, but each new backup replaces the previous one. If you have not backed up recently, your stored copy may be older than you expect.',
          },
        ],
      },
    ],
  },

  'banned-account': {
    h1: 'GB WhatsApp Banned Account – What to Do',
    subtitle: 'Saw a "temporarily banned" message? Here is what it means, why it happens, and how to handle it.',
    badge: 'Troubleshooting',
    sections: [
      {
        h2: 'Types of WhatsApp Bans',
        paragraphs: [
          'A temporary ban usually displays a countdown timer and often happens when you use an outdated mod version, send too many messages too quickly, or get reported for spam. The ban lifts automatically once the timer reaches zero, and your chats typically remain intact throughout.',
          'A permanent ban means your phone number can no longer use WhatsApp at all — this is rare but possible with mod apps, especially if you ignore repeated temporary warnings. Do not panic during a temporary ban; wait for the timer, update to the latest version, and avoid trying to re-register before the countdown ends, as that can extend the ban.',
        ],
      },
      {
        h2: 'What to Do During a Temporary Ban',
        steps: [
          'Do NOT try to register again — this can extend the ban.',
          'Wait for the timer to reach zero.',
          'Update to the latest GB WhatsApp version before reopening the app.',
          'Download the newest APK from our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a>.',
          'Open the app only after the ban timer ends.',
        ],
      },
      {
        h2: 'How to Reduce Ban Risk',
        list: [
          'Always use the latest GB WhatsApp version',
          'Do not send bulk messages to unknown contacts',
          'Avoid using auto-reply or mass-forwarding tools aggressively',
          'Do not switch between mod apps frequently',
          'Back up chats regularly',
        ],
        paragraphs: [
          'Prevention is far easier than dealing with a ban after the fact. Keeping your app updated, messaging responsibly, and avoiding aggressive automation tools significantly lowers your risk. After a ban lifts, follow our <a href="/gb-whatsapp-update/"><strong>GB WhatsApp update guide</strong></a> to install the newest APK before reopening the app.',
          'For a deeper look at what triggers bans and how anti-ban features work, read our ban risk safety page before using mods on an important phone number.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Will I lose my chats after a ban?',
            answer: 'Temporary bans do not delete your chats — your messages should still be there when the ban lifts and you reopen the app. Permanent bans are different, since you would need a new number to use WhatsApp again.',
          },
          {
            question: 'Can I use a different number?',
            answer: 'Yes, but your old chats are tied to the banned number and cannot be transferred. You would start fresh with a new number and need to set up a new backup from scratch.',
          },
        ],
      },
    ],
  },
};
